<template>
  <section class="hero custom-color">
    <div class="hero-body">
      <p class="title">
        {{ titulo }}
      </p>
     
      <p class="subtitle" @click="ejecutarFuncion">
        {{ subtitulo }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "mensajeInicial",
  props: ["titulo", "subtitulo"],
  methods: {
    ejecutarFuncion() {
      // Lógica de la función que deseas ejecutar
      console.log("Función ejecutada al hacer clic en el subtítulo");
      // Puedes agregar aquí la lógica específica que deseas ejecutar
    },
  },
};
</script>

<style scoped>
/* Estilos específicos para esta instancia */
.custom-color {
  background-color:  #8ca1fd;  /* Cambia esto al color que desees */
  /* Otros estilos según sea necesario */
  cursor: pointer; /* Cambia el cursor al estilo de mano para indicar que es clickeable */
}
</style>
